module.exports = __webpack_public_path__ + "static/media/sketch-inverted-cvo-tri-glide.5d8ab2e2.png";